export default __webpack_public_path__ + "26542582d55b2ea1adb41ec85dd220ff.png";